import { ItemFilter } from '~services/item/types';
import { DriverCompanyBase } from '~services/driver/types';
import { SelectOption } from '~globals/types';
import { LogisticZoneBase } from '~services/logisticsZones/types';
import { DEFAULT_UUIID_EMPTY } from '~constants/commons';
import { OrdersSearchFilters } from '~hooks/useOrdersSearchFilters';

export const ORDER_KEY_ID = 'itemId';

export const DEFAULT_SERVICE_TYPE_OPTION: SelectOption = {
  value: '_unassigned',
  label: 'Sin asignar',
};

export const DEFAULT_DRIVER_OPTION: DriverCompanyBase = {
  code: null,
  displayName: 'Sin asignar',
  enabled: true,
  id: DEFAULT_UUIID_EMPTY,
  avatar: null,
};

export const DEFAULT_ZONE_OPTION: LogisticZoneBase = {
  code: 'Sin asignar',
  color: '',
  description: '',
  zoneId: DEFAULT_UUIID_EMPTY,
};

export const DEFAULT_PAGINATION = {
  page: 1,
  sizePerPage: 50,
};

export const DEFAULT_FILTERS_STATE: OrdersSearchFilters = {
  dateFrom: null,
  dateTo: null,
  search: '',
  expirationDate: null,
  states: [],
  drivers: null,
  vehicles: null,
  services: null,
  zones: null,
  priceGt: '',
  priceLt: '',
  assignedUser: null,
};

export const DEFAULT_FILTERS_PAYLOAD: ItemFilter = {
  dateFrom: null,
  dateTo: null,
  driversId: null,
  vehiclesId: null,
  routeCode: null,
  routeItemStateTypesId: [],
  maxDeliveredDateTime: null,
  collectItemStateTypesId: [],
  serviceTypeList: null,
  zonesId: null,
  unit1GraterThan: null,
  unit1LowerThan: null,
  unit2GraterThan: null,
  unit2LowerThan: null,
  priceGraterThan: null,
  priceLowerThan: null,
  assignedUserId: null,
};
